import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'acscp/web/components/root';
import { configureStore } from './store/configureStore';
import './index.scss';

ReactDOM.render(<Root store={configureStore()}/>,
    document.getElementById('root'));
